import styles from './WheelOfFortuneModeSwitcher.module.scss';
import { useDispatch, useSelector } from "../../../hooks";
import { WheelOfFortuneMode, wheelOfFortuneSetMode } from "../../../redux/games/wheel-of-fortune";
import { FC } from 'react';

const modes = ["Бесплатный", "Продвинутый", "Премиум"];

interface IWheelOfFortuneModeSwitcherProps {
    isSpinning: boolean;
}

export const WheelOfFortuneModeSwitcher: FC<IWheelOfFortuneModeSwitcherProps> = ({ isSpinning }) => {
    const currentMode = useSelector(store => store.games.wheelOfFortune.mode);
    const dispatch = useDispatch()

    const handler = (mode: WheelOfFortuneMode) => {
        if (isSpinning === true)
            return;

        dispatch(wheelOfFortuneSetMode(mode));
    }

    return (
        <div className={ styles.container }>
            { modes.map((mode, index) => (
                <label
                    key={`mode${index}`}
                    className={ styles.mode }
                >
                    <span className={styles.caption}>{mode}</span>
                    <input
                        type="radio"
                        name="mode"
                        checked={currentMode === index + 1}
                        onChange={() => handler(index + 1)}
                    />
                    <span className={styles.radioCustom}></span>
                </label>
            ))}
        </div>
    );
}